import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TarifasFactoringComponent } from '../footer/factoring/tarifas-factoring/tarifas-factoring.component';
import { Router } from '@angular/router';
import { DOMAIN_ENVIRONMENT } from 'src/app/_services/base.service';
import { SharedModule } from 'src/app/_shared/_shared.module';
import { BannerPortadaComponent } from 'src/app/home/banner-portada/banner-portada.component';
import { LineasInversionComponent } from 'src/app/home/lineas-inversion/lineas-inversion.component';
import { AhorraInvierteRentabilizaComponent } from 'src/app/home/ahorra-invierte-rentabiliza/ahorra-invierte-rentabiliza.component';
import { EstadisticasPlataformaComponent } from 'src/app/home/estadisticas-plataforma/estadisticas-plataforma.component';
import { ValoracionClientesComponent } from 'src/app/home/valoracion-clientes/valoracion-clientes.component';
import { CitaDtoInversoresComponent } from 'src/app/home/cita-dto-inversores/cita-dto-inversores.component';
import { NoticiasPrensaComponent } from 'src/app/home/noticias-prensa/noticias-prensa.component';
import { HomeCasosExitoComponent } from 'src/app/home/home-casos-exito/home-casos-exito.component';
import { HomeFaqsComponent } from 'src/app/home/home-faqs/home-faqs.component';
import { HomeFundsComponent } from 'src/app/funds/shared/home/home-funds/home-funds.component';
import { CodigoPromocionalComponent } from 'src/app/funds/shared/codigo-promocional/codigo-promocional.component';
import { PorqueMyInvestorComponent } from 'src/app/home/porque-my-investor/porque-my-investor.component';
import { HomeFactoringComponent } from 'src/app/factoring/shared/home/home-factoring.component';
import { TiposOperacionesComponent } from 'src/app/home/tipos-operaciones/tipos-operaciones.component';
import { VentajasComponent } from 'src/app/_shared/bloque-secciones-reutilizables/ventajas/ventajas.component';
import { ContactenosComponent } from 'src/app/_shared/bloque-secciones-reutilizables/contactenos/contactenos.component';
import { AsociacionesIndexComponent } from 'src/app/footer/segofinance/asociaciones-index/asociaciones-index.component';
import { SectionVentaja, Ventaja } from 'src/app/_shared/bloque-secciones-reutilizables/_models/ventaja';
import { PlatformService } from 'src/app/_services/platform.service';
import { Contactanos } from 'src/app/_shared/bloque-secciones-reutilizables/_models/contactanos';



@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: true,
  imports: [
    SharedModule,
    BannerPortadaComponent,
    LineasInversionComponent,
    AhorraInvierteRentabilizaComponent,
    EstadisticasPlataformaComponent,
    ValoracionClientesComponent,
    CitaDtoInversoresComponent,
    NoticiasPrensaComponent,
    HomeCasosExitoComponent,
    HomeFaqsComponent,
    HomeFundsComponent,
    CodigoPromocionalComponent,
    PorqueMyInvestorComponent,
    ContactenosComponent,
    HomeFactoringComponent,
    TiposOperacionesComponent,
    VentajasComponent,
    AsociacionesIndexComponent
  ]
})


export class HomeComponent implements OnInit
{
  plataformaId: string;
  ayudaDataFunds: Contactanos;
  ayudaDataFactoring: Contactanos;
  ayudaDataCNMV: Contactanos;
  ventajasData: Ventaja[];
  sectionVentajaData: SectionVentaja;
  lineaNegocioActiva: string;

  constructor(
    private _router: Router,
    private _platformService: PlatformService,
    private _dialog: MatDialog
  ) { }

  ngOnInit(): void
  {
    this.getPlataforma();
    this.checkOpenTarifasFactoring();
    this.getContactanosData();
    this.getVentajasData();
  }

  private getVentajasData(): void
  {
    this.ventajasData = [
      {
        icono: 'emoji_events',
        iconClass: 'mat-icon-size-22 secondary-factoring-500',
        borderColor: 'secondary-factoring-500',
        titulo: 'ANÁLISIS RIGUROSO',
        subtitulo: 'Los analistas de SEGO estudian exhaustivamente que todas y cada una de las empresas cumplan los requisitos de solvencia, liquidez y riesgos exigidos.'
      },
      {
        icono: 'psychology',
        iconClass: 'mat-icon-size-22 secondary-factoring-500',
        borderColor: 'secondary-factoring-500',
        titulo: 'AUTOINVEST',
        subtitulo: 'Los inversores pueden personalizar y automatizar las inversiones para que, de forma pasiva, optimicen sus ganancias.'
      },
      {
        icono: 'account_tree',
        iconClass: 'mat-icon-size-22 secondary-factoring-500',
        borderColor: 'secondary-factoring-500',
        titulo: 'DIVERSIFICACIÓN',
        subtitulo: 'El inversor puede distribuir el capital entre diferentes tipos de operaciones, empresas, rentabilidad, plazo y riesgo.'
      },
      {
        icono: 'swipe',
        iconClass: 'mat-icon-size-22 secondary-factoring-500',
        borderColor: 'secondary-factoring-500',
        titulo: 'SEGUIMIENTO',
        subtitulo: 'Ante cualquier posible retraso o disputa, el departamento legal de SEGO Factoring se encargará de todos los trámites legales y costes adheridos.'
      },
    ];

    this.sectionVentajaData = {
      refSwiper: 'swiper-ventajas-home',
      titulo: '¿QUÉ NOS HACE DIFERENTES?',
      tituloClass: 'primary-500 tab-ancla mb-2',
      subtitulo: 'Ventajas de invertir en SEGO Factoring',
      subtituloClass: 'primary-900',
      btnTexto: 'Comenzar a Invertir',
      btnRuta: '/oportunidades-inversion',
    }
  }

  getContactanosData(): void
  {
    switch (this.plataformaId)
    {
      case 'FUNDS':
        this.ayudaDataFunds = {
          titulo: 'ESTAMOS PARA AYUDARTE',
          pregunta: '¿Ya eres cliente de MyInvestor?',
          subtitulo: 'Si quieres disfrutar de estas condiciones, escríbenos para ver tu caso',
          btnText: 'Contáctanos',
          btnRuta: 'https://outlook.office365.com/book/SEGOInversores@segofinance.com/',
          icon: 'event'
        };
        break;
      case 'FACTORING':
        this.ayudaDataFactoring = {
          titulo: 'DEPARTAMENTO DE INVERSORES',
          pregunta: '¿Todavía no sabes en qué invertir?',
          subtitulo: 'Ponemos a tu disposición un equipo de expertos que te ayudarán a conocer mejor nuestros productos para que puedas decidir qué producto encaja mejor con tu perfil. ',
          btnText: 'Reserva tu llamada',
          btnRuta: 'https://outlook.office365.com/book/SEGOInversores@segofinance.com/',
          icon: 'event'
        };
        break;
      case 'VENTURE':
      case 'REALESTATE':
      case 'CREATIVE':
      case 'SEGOFINANCE':
        this.ayudaDataCNMV = {
          titulo: 'DEPARTAMENTO DE INVERSORES',
          pregunta: '¿Todavía no sabes en qué invertir?',
          subtitulo: 'Ponemos a tu disposición un equipo de expertos que te ayudarán a conocer mejor nuestros productos para que puedas decidir qué producto encaja mejor con tu perfil. ',
          btnText: 'Reserva tu llamada',
          btnRuta: 'https://outlook.office365.com/book/SEGOInversores@segofinance.com/',
          icon: 'event'
        };
        break;
    }
  }

  private getPlataforma(): void
  {
    this.plataformaId = DOMAIN_ENVIRONMENT[this._platformService._domainEnvironment];
  }

  checkOpenTarifasFactoring()
  {
    if (this._router.url == "/legal/factoring/tarifas-comisiones")
    {
      this._router.navigateByUrl('/');
      this._dialog.open(TarifasFactoringComponent, { autoFocus: false, panelClass: 'dialog-tarifas' });
    }
  }
}
